import { useEffect, useMemo, useRef } from 'react'
import { Form, FormInstance } from 'antd'

export interface RelateFieldConfig {
  fieldKey: string
  relateField?: string
  relateFieldEnumValue?: string
  projectCode: string
}

/**
 * 关联字段 Hook
 * 用于处理表单中关联字段的禁用状态和值清空逻辑
 * @param fields 需要处理的字段配置数组
 * @param form 表单实例
 * @param projectCode 项目编码
 * @returns 返回每个字段的禁用状态
 */
export const useRelateField = (
  fields: RelateFieldConfig[],
  form: FormInstance,
  projectCode: string,
) => {
  // 用于标记是否是初始化阶段
  const isInitializing = useRef(true)
  const initializationTimer = useRef<NodeJS.Timeout | null>(null)

  // 过滤出有关联字段的配置
  const fieldsWithRelateField = useMemo(() => {
    return fields.filter(
      (field) => field.relateField && field.relateFieldEnumValue,
    )
  }, [fields])

  // 获取所有关联字段的名称
  // const relateFieldNames = useMemo(() => {
  //   return fieldsWithRelateField.map(
  //     (field) => `${projectCode}_${field.relateField}`,
  //   )
  // }, [fieldsWithRelateField, projectCode])

  // 监听所有关联字段的值变化 - 使用数组形式
  // const relateFieldValues = Form.useWatch(relateFieldNames, form)

  // 计算每个字段的禁用状态
  const disabledStates = useMemo(() => {
    const states: Record<string, boolean> = {}

    fieldsWithRelateField.forEach((field, index) => {
      // 使用form.getFieldValue来获取字段值，避免useWatch的问题
      const relateFieldName = `${projectCode}_${field.relateField}`
      const relateFieldValue = form.getFieldValue(relateFieldName)

      const isDisabled =
        field.relateField && field.relateFieldEnumValue
          ? !field.relateFieldEnumValue.split(',').includes(relateFieldValue)
          : false

      states[field.fieldKey] = isDisabled
    })

    return states
  }, [fieldsWithRelateField, form, projectCode])

  // 监听关联字段值变化，处理字段值清空
  useEffect(() => {
    if (!projectCode || !fieldsWithRelateField?.length) return

    // 如果是初始化阶段，延迟执行关联字段逻辑
    if (isInitializing.current) {
      // 清除之前的定时器
      if (initializationTimer.current) {
        clearTimeout(initializationTimer.current)
      }

      // 设置延迟，确保表单数据完全设置完成
      initializationTimer.current = setTimeout(() => {
        isInitializing.current = false
        // 延迟执行关联字段逻辑
        fieldsWithRelateField.forEach((field) => {
          const relateFieldName = `${projectCode}_${field.relateField}`
          const relateFieldValue = form.getFieldValue(relateFieldName)
          const currentFieldName = `${projectCode}_${field.fieldKey}`

          if (relateFieldValue !== undefined) {
            const relateFieldEnumValues =
              field.relateFieldEnumValue?.split(',') || []
            const isEnabled = relateFieldEnumValues.includes(relateFieldValue)

            // 如果当前字段应该被禁用（即关联字段的值不在允许的枚举值列表中）
            if (!isEnabled) {
              // console.log(
              //   '初始化阶段清空字段:',
              //   currentFieldName,
              //   '关联字段值:',
              //   relateFieldValue,
              // )
              // 清空当前字段的值
              form.setFieldsValue({
                [currentFieldName]: undefined,
                [`${currentFieldName}_name`]: undefined,
              })
            }
          }
        })
      }, 100) // 延迟100ms执行

      return
    }

    // 非初始化阶段，正常执行关联字段逻辑
    fieldsWithRelateField.forEach((field) => {
      const relateFieldName = `${projectCode}_${field.relateField}`
      const relateFieldValue = form.getFieldValue(relateFieldName)
      const currentFieldName = `${projectCode}_${field.fieldKey}`

      if (relateFieldValue !== undefined) {
        const relateFieldEnumValues =
          field.relateFieldEnumValue?.split(',') || []
        const isEnabled = relateFieldEnumValues.includes(relateFieldValue)

        // 如果当前字段应该被禁用（即关联字段的值不在允许的枚举值列表中）
        if (!isEnabled) {
          // console.log(
          //   '正常阶段清空字段:',
          //   currentFieldName,
          //   '关联字段值:',
          //   relateFieldValue,
          // )
          // 清空当前字段的值
          form.setFieldsValue({
            [currentFieldName]: undefined,
            [`${currentFieldName}_name`]: undefined,
          })
        }
      }
    })
  }, [projectCode, fieldsWithRelateField, form])

  // 清理定时器
  useEffect(() => {
    return () => {
      if (initializationTimer.current) {
        clearTimeout(initializationTimer.current)
      }
    }
  }, [])

  return {
    disabledStates,
    fieldsWithRelateField,
  }
}
import { useEffect, useMemo, useRef } from 'react'
import { Form, FormInstance } from 'antd'

export interface RelateFieldConfig {
  fieldKey: string
  relateField?: string
  relateFieldEnumValue?: string
  projectCode: string
}

/**
 * 关联字段 Hook
 * 用于处理表单中关联字段的禁用状态和值清空逻辑
 * @param fields 需要处理的字段配置数组
 * @param form 表单实例
 * @param projectCode 项目编码
 * @returns 返回每个字段的禁用状态
 */
export const useRelateField = (
  fields: RelateFieldConfig[],
  form: FormInstance,
  projectCode: string,
) => {
  // 用于标记是否是初始化阶段
  const isInitializing = useRef(true)
  const initializationTimer = useRef<NodeJS.Timeout | null>(null)

  // 过滤出有关联字段的配置
  const fieldsWithRelateField = useMemo(() => {
    return fields.filter(
      (field) => field.relateField && field.relateFieldEnumValue,
    )
  }, [fields])

  // 获取所有关联字段的名称
  // const relateFieldNames = useMemo(() => {
  //   return fieldsWithRelateField.map(
  //     (field) => `${projectCode}_${field.relateField}`,
  //   )
  // }, [fieldsWithRelateField, projectCode])

  // 监听所有关联字段的值变化 - 使用数组形式
  // const relateFieldValues = Form.useWatch(relateFieldNames, form)

  // 计算每个字段的禁用状态
  const disabledStates = useMemo(() => {
    const states: Record<string, boolean> = {}

    fieldsWithRelateField.forEach((field, index) => {
      // 使用form.getFieldValue来获取字段值，避免useWatch的问题
      const relateFieldName = `${projectCode}_${field.relateField}`
      const relateFieldValue = form.getFieldValue(relateFieldName)

      const isDisabled =
        field.relateField && field.relateFieldEnumValue
          ? !field.relateFieldEnumValue.split(',').includes(relateFieldValue)
          : false

      states[field.fieldKey] = isDisabled
    })

    return states
  }, [fieldsWithRelateField, form, projectCode])

  // 监听关联字段值变化，处理字段值清空
  useEffect(() => {
    if (!projectCode || !fieldsWithRelateField?.length) return

    // 如果是初始化阶段，延迟执行关联字段逻辑
    if (isInitializing.current) {
      // 清除之前的定时器
      if (initializationTimer.current) {
        clearTimeout(initializationTimer.current)
      }

      // 设置延迟，确保表单数据完全设置完成
      initializationTimer.current = setTimeout(() => {
        isInitializing.current = false
        // 延迟执行关联字段逻辑
        fieldsWithRelateField.forEach((field) => {
          const relateFieldName = `${projectCode}_${field.relateField}`
          const relateFieldValue = form.getFieldValue(relateFieldName)
          const currentFieldName = `${projectCode}_${field.fieldKey}`

          if (relateFieldValue !== undefined) {
            const relateFieldEnumValues =
              field.relateFieldEnumValue?.split(',') || []
            const isEnabled = relateFieldEnumValues.includes(relateFieldValue)

            // 如果当前字段应该被禁用（即关联字段的值不在允许的枚举值列表中）
            if (!isEnabled) {
              // console.log(
              //   '初始化阶段清空字段:',
              //   currentFieldName,
              //   '关联字段值:',
              //   relateFieldValue,
              // )
              // 清空当前字段的值
              form.setFieldsValue({
                [currentFieldName]: undefined,
                [`${currentFieldName}_name`]: undefined,
              })
            }
          }
        })
      }, 100) // 延迟100ms执行

      return
    }

    // 非初始化阶段，正常执行关联字段逻辑
    fieldsWithRelateField.forEach((field) => {
      const relateFieldName = `${projectCode}_${field.relateField}`
      const relateFieldValue = form.getFieldValue(relateFieldName)
      const currentFieldName = `${projectCode}_${field.fieldKey}`

      if (relateFieldValue !== undefined) {
        const relateFieldEnumValues =
          field.relateFieldEnumValue?.split(',') || []
        const isEnabled = relateFieldEnumValues.includes(relateFieldValue)

        // 如果当前字段应该被禁用（即关联字段的值不在允许的枚举值列表中）
        if (!isEnabled) {
          // console.log(
          //   '正常阶段清空字段:',
          //   currentFieldName,
          //   '关联字段值:',
          //   relateFieldValue,
          // )
          // 清空当前字段的值
          form.setFieldsValue({
            [currentFieldName]: undefined,
            [`${currentFieldName}_name`]: undefined,
          })
        }
      }
    })
  }, [projectCode, fieldsWithRelateField, form])

  // 清理定时器
  useEffect(() => {
    return () => {
      if (initializationTimer.current) {
        clearTimeout(initializationTimer.current)
      }
    }
  }, [])

  return {
    disabledStates,
    fieldsWithRelateField,
  }
}
